// Catálogo das parametrizações do inquilino exibidas em Configurações.
// Cada tipo pertence a uma categoria e declara os campos complementares
// (referencia/texto) que o backend lê para ele.

export const CATEGORIAS_PARAMETRIZACAO = [
  {
    id: "registroPonto",
    icone: "mdi-map-marker-radius-outline",
    tipos: [
      "CERCAELETRONICAMETROS",
      "TOLERANCIAPERIMETROMETROSRELATORIOS",
      "INTERVALOREGISTROPONTOMINUTOS",
      "ANTECIPACAO01HORARIO",
      "ANTECIPACAOHORARIO",
      "ATRASO01HORARIO",
      "ATRASOULTIMOHORARIO",
      "ATRASOHORARIO",
      "REGISTROFORADIAESCALA",
      "EXIGIRRECONHECIMENTOFACIALEDESABILITARSENHA",
      "DESABILITARBIOMETRIAFACIALREGISTROPONTO",
      "RESTRINGIRJUSTIFICATIVAREGISTROPONTO",
      "REGISTROPONTOWEBEXIGIRIMAGEM",
      "REGISTROPONTOWEBPERMITIRREGISTRODASHBOARDPROPRIO",
      "DESABILITARFERIADOESTADUALMUNICIPAL",
    ],
  },
  {
    id: "calculoPonto",
    icone: "mdi-calculator-variant-outline",
    tipos: [
      "DEFINICAOBANCOHORASCALCULO",
      "HEEXTRASEMPREBH",
      "HEEXTRA50SEMPREBH",
      "INCONSISTENCIACALCULOPONTOQUANTIDADEMENOR4REGISTROS",
      "APROVACAOHORASCALCULOPONTO",
      "CALCULOPONTOPOSSIBILITARVALIDACAOGESTOR",
      "CALCULOPONTOHORASEMHORADECIMALTELA",
      "PONTOSOLICITACAO02VALIDACOES",
      "MULTIPLOSPERIODOSPONTO",
      "ENCERRARPERIODOPONTOCOMINCONSISTENCIA",
      "REABRIRPERIODOPONTOCOMASSINATURA",
      "EMAILNOTIFICACOESCALCULOPONTO",
    ],
  },
  {
    id: "folhaPontoRecibos",
    icone: "mdi-file-document-outline",
    tipos: [
      "MENSAGEMFOLHAPONTO",
      "FOLHAPONTOMODELO02",
      "FOLHAPONTOMODELO03",
      "FOLHAPONTOMODELO05",
      "FOLHAPONTOMODELO06",
      "FOLHAPONTOMODELO07",
      "FOLHAPONTOMODELO08",
      "FOLHAPONTOMODELO09",
      "FOLHAPONTOMODELO10",
      "FOLHAPONTOMODELO11",
      "FOLHAPONTOMODELO12",
      "FOLHAPONTOMODELO13",
      "FOLHAPONTOMODELO14",
      "FOLHAPONTOMODELO15",
      "FOLHAPONTOMODELO16",
      "FOLHAPONTOMODELO17",
      "FOLHAPONTOAGRUPARCOMEXTRATOBH",
      "FOLHAPONTOVALIDACAOEMPRESA",
      "BLOQUEARFOLHAPONTOPERIODOABERTO",
      "MENSAGEMRECIBOPAGAMENTO",
      "IMAGEMRODAPERECIBOPAGAMENTO",
      "RECIBOPAGAMENTOMODELO02",
      "RECIBOPAGAMENTOMODELO03",
    ],
  },
  {
    id: "afastamentos",
    icone: "mdi-calendar-remove-outline",
    tipos: [
      "AFASTAMENTOSOLICITACAO01VALIDACAO",
      "AFASTAMENTOSOLICITACAO02VALIDACOES",
      // "FUNCIONARIOAFASTAMENTOLIMITACAOPERIODO",
      // "SOLICITACAOAFASTAMENTOATESTADOCOMPARECIMENTOPARAHORASABONADAS",
      // "SOLICITACAOAFASTAMENTOLIMITEDIASSOLIITACAOATESTADOMEDICO",
    ],
  },
  {
    id: "appPortal",
    icone: "mdi-cellphone",
    tipos: [
      "ULTIMOSREGISTROSAPP",
      "APPULTIMOSREGISTROSPONTOAGRUPADOSCOMPETENCIA",
      "APPPERMITIRAJUSTEENDERECOEMAIL",
      "CONTRACHEQUEAPP",
      "FOLHAPONTOAPP",
      "BANCOHORASAPP",
      "COMUNICACAOINTERNAAPP",
      "HABILITARPORTALDOTRABALHADOR",
      "PORTALCOLABORADORVISUALIZARDOCUMENTOSGED",
      "PORTALTRABALHADORAUSENCIASPORINTERVALO",
      "APPDESABILITARCAPTURAIMAGEMSIMPLIFICADA",
      "CADASTROFACETERCEIROAPP",
      "APPBLOQUEARREGISTROPONTOMODOPRIVADO",
      "APPSOLICITACAOAFASTAMENTO",
      // "APPSOLICITACAOAFASTAMENTOOPCOES",
      "APPSOLICITACAOAFASTAMENTOATESTADOSOLICITARIMAGEMHOMOLOGACAO",
      "APPPERMITIRVALIDARIMAGEMSOLICITACAOAFASTAMENTO",
      "APPVISUALIZARLIVROOCORRENCIASAPENASAOREGISTRARPONTODATA",
      "APPVISUALIZARLIVROOCORRENCIASAPENASCOMPERMISSAO",
      "APPREQUISITARPERMISSAOLANCAMENTOSPESSOAIS",
      "APPPOSSIBILITARENVIOCOMPROVANTEPONTO",
      "APPEXIGIRCOMPROVANTESOLICITACAOPONTO",
      "APPDESABILITAROBRIGATORIEDADENR1",
    ],
  },
  {
    id: "folhaPagamento",
    icone: "mdi-swap-horizontal",
    tipos: [
      "CODIGOEMPRESAFP",
      "INTEGRACAOFPHUMANUS",
      "INTEGRACAOFPTHOMSON",
      "INTEGRACAOFPDEXION",
      "INTEGRACAOTOTVS",
      "INTEGRACAOTOTVSBODYCALCULOFOLHAPAGTO",
      "INTEGRACAOFPALTERDATA",
      "INTEGRACAOFPFORTES",
      "INTEGRACAOFPLIDERW",
      "INTEGRACAOFPDATAMACE",
      "INTEGRACAO_FP_SIP_FOLHA_PAGAMENTO",
      "INTEGRACAOFPQUESTOR",
    ],
  },
  {
    id: "pessoal",
    icone: "mdi-account-group-outline",
    tipos: [
      "CONTRATACAOEXIGIRUNIFORME",
      "CONTRATACAOEXIGIRMOVIMENTACAO",
      "INFORMACAORESUMIDAVALETRANSPORTECONTRATACAOFUNCIONARIO",
      "INSERIRCONTRATACOESEMREGISTRADORESEXTERNOS",
      "ADICIONARFUNCIONARIOEMFORNECEDOR",
      "BENEFICIOCALCULOSEMAPURACAOPONTO",
      "MULTIPLOSPERIODOSAPURACAOBENEFICIO",
      "NOTIFICACAOANIVERSARIOFUNCIONARIOS",
      "EMAILGESTAOEFETIVO",
      "EMAILNOTIFICACAONOVASCONTRATACOES",
      "EMAILNOTIFICACAODESLIGAMENTOS",
    ],
  },
  {
    id: "faturamentoFiscal",
    icone: "mdi-receipt-text-outline",
    tipos: [
      "CONTAFINANCEIRAFATURAMENTOSERVICOS",
      "CONTAFINANCEIRAFATURAMENTOSERVICOSCONTAVINCULADA",
      "OPTANTESIMPLESNACIONAL",
      "TOKENEMISSAODOCUMENTOFISCAL",
      "EMAILDOCUMENTOSFISCAIS",
      "FATURAMENTOABRIRCALCULOITEM",
      "FATURAMENTODEDUCAOBASEINSSVARIAVEL",
      "FATURAMENTOARREDONDARVALORES",
      "FATURAMENTOSEPARARCALCULOMENSALVARIAVEL",
      "CALCULOFATURAMENTOMESATUAL",
      "FATURAMENTOEMISSAONFSESEGUIRDATAGERACAODOCUMENTO",
      "BLOQUEARENVIOFATURAMENTOEMAIL",
      "CTEHOMOLOGACAO",
      "GTVEPARAMETRIZACAOFISCAL",
      "CODIGORNTRC",
    ],
  },
  {
    id: "financeiro",
    icone: "mdi-bank-outline",
    tipos: [
      "CENTROCUSTOPADRAOANALISES",
      "CONTAFINANCEIRAPADRAOTRANSFERENCIABNCARIADEBITOCREDITO",
      "IMPEDIRREMOCAOAUTOMATICATITULOSPREVISAO",
      "FINANCEIROINATIVARPREVISAOCOMPENSACAO",
      "LANCAMENTOSCONTABEISCONTADESCONTOSOBTIDOS",
      "LANCAMENTOSCONTABEISCONTADESCONTOSCONCEDIDOS",
      "LANCAMENTOSCONTABEISCONTAJUROSMORA",
      "LANCAMENTOSCONTABEISCONTAMULTASMORA",
      "LANCAMENTOSCONTABEISCONTAJUROSRECEBIDOS",
      "LANCAMENTOSCONTABEISCONTAMULTASRECEBIDOS",
      "GESTAOORCAMENTODESPESADESABILITARINTTITULOS",
      "EMAILNOTIFICACAOGESTAOORCAMENTODESPESAS",
      "EMAILGESTAOCOMERCIAL",
      "SOLICITACAOORCAMENTODESABILITARBIOMETRIAFACIAL",
    ],
  },
  {
    id: "suprimentos",
    icone: "mdi-package-variant-closed",
    tipos: [
      "CONTAFINANCEIRAPEDIDOCOMPRAAUTOMATICOMATERIAIS",
      "CONTAFINANCEIRAPEDIDOCOMPRAAUTOMATICOCONSUMIVEIS",
      "CONTAFINANCEIRAPEDIDOCOMPRAAUTOMATICOUNIFORMES",
      "COMPRASAPROVACAOORCAMENTOPORITEM",
      "COMPRASPEDIDOAUTOMATICOSEPARARCENTROESTOQUE",
      "COMPRASGERACAOAUTOMATICACONSIDERARAPENASSOLICITACOES",
      "COMPRASCONTROLESOLICITACOESPERIODO",
      "COMPRASSOLICITACAOCOMPRAEDEFINICAOESTOQUE",
      "COMPRASCONTAGEMFINALIZACAODIAINICIAL",
      "COMPRASCONTAGEMFINALIZACAODIAFINAL",
      "COMPRASENTREGAPOREMBALAGEMAQUISICAO",
      "COMPRASPERCENTUALEMBALAGEMFECHADA",
      "COMPRASEXPORTACAOROTEIRIZACAOENTREGAS",
      "COMPRASDESABILITARINTEGRACAOFINANCEIRA",
      "MULTIPLOSCENTROSESTOQUE",
      "EMAILNOTIFICACAOSOLICITACAOMATERIALTEMPORARIO",
      "EMAILNOTIFICACAOSOLICITACAOCONSUMIVEL",
      "EMAILNOTIFICACAOSOLICITACAOUNIFORME",
      "UNIFORMENOTIFICACAODATASUBSTITUICAO",
      "UNIFORMEPERMITIRVINCULOPESSOA",
      "SOLICITACAOUNIFORMEREMOVERFLUXOENTREGA",
    ],
  },
  {
    id: "operacoes",
    icone: "mdi-shield-car",
    tipos: [
      "LIVROOCORRENCIASPOSTOTRABALHO",
      "REGISTRONOVATAREFASOLICITARIMAGEM",
      "ARMAFOGONOTIFICACAOVINCUMENTOREGISTRO60DIAS",
      "COLETEBALISTICONOTIFICACAOVINCUMENTOREGISTRO90DIAS",
      "INTEGRACAOEQUIPAMENTOSPRIME",
      "INTEGRACAOEQUIPAMENTOSADVANCE",
      "INTEGRACAOEQUIPAMENTOSMASTERCOIN",
      "INTEGRACAOEQUIPAMENTOSGUNNEBO",
      "INTEGRACAOEQUIPAMENTOSELUMAQUINAS",
      // "INTEGRARMOVIMENTACOESEQUIPAMENTOSSATELLITE",
      "EMAILNOTIFICACAOLIMITECOLETAEQUIPAMENTOS",
      "EMAILALERTASALDOTESOURARIA",
      "TOLERANCIACONCOMITANCIATRANSPORTE",
      "BRADESCOAPIKEY",
      "BRADESCOCLIENTID",
      "BRADESCOAPISENHACONEXAO",
      "BRADESCOAPIKEYHOMOLOGACAO",
      "BRADESCOCLIENTIDHOMOLOGACAO",
      "BRADESCOAPISENHACONEXAOHOMOLOGACAO",
    ],
  },
];

// Registros salvos com tipos fora do catálogo continuam visíveis aqui.
export const CATEGORIA_OUTROS = {
  id: "outros",
  icone: "mdi-dots-horizontal-circle-outline",
  tipos: [],
};

// Tipos que usam o campo referencia e a unidade do valor, quando conhecida.
const REFERENCIA_POR_TIPO = {
  CERCAELETRONICAMETROS: "metros",
  TOLERANCIAPERIMETROMETROSRELATORIOS: "metros",
  INTERVALOREGISTROPONTOMINUTOS: "minutos",
  ANTECIPACAO01HORARIO: "minutos",
  ANTECIPACAOHORARIO: "minutos",
  ATRASO01HORARIO: "minutos",
  ATRASOULTIMOHORARIO: "minutos",
  ATRASOHORARIO: "minutos",
  SOLICITACAOAFASTAMENTOLIMITEDIASSOLIITACAOATESTADOMEDICO: "dias",
  FUNCIONARIOAFASTAMENTOLIMITACAOPERIODO: null,
  UNIFORMENOTIFICACAODATASUBSTITUICAO: null,
  TOLERANCIACONCOMITANCIATRANSPORTE: "minutos",
  COMPRASPERCENTUALEMBALAGEMFECHADA: "percentual",
  COMPRASCONTAGEMFINALIZACAODIAINICIAL: null,
  COMPRASCONTAGEMFINALIZACAODIAFINAL: null,
};

const TIPOS_TEXTO = new Set([
  "CONTAFINANCEIRAFATURAMENTOSERVICOS",
  "MENSAGEMFOLHAPONTO",
  "MENSAGEMRECIBOPAGAMENTO",
  "CODIGOEMPRESAFP",
  "TOKENEMISSAODOCUMENTOFISCAL",
  "CENTROCUSTOPADRAOANALISES",
  "CONTAFINANCEIRAPEDIDOCOMPRAAUTOMATICOMATERIAIS",
  "CONTAFINANCEIRAPEDIDOCOMPRAAUTOMATICOCONSUMIVEIS",
  "CONTAFINANCEIRAPEDIDOCOMPRAAUTOMATICOUNIFORMES",
  "EMAILDOCUMENTOSFISCAIS",
  "EMAILGESTAOEFETIVO",
  "ARMAFOGONOTIFICACAOVINCUMENTOREGISTRO60DIAS",
  "COLETEBALISTICONOTIFICACAOVINCUMENTOREGISTRO90DIAS",
  "EMAILALERTASALDOTESOURARIA",
  "EMAILNOTIFICACOESCALCULOPONTO",
  "EMAILGESTAOCOMERCIAL",
  "INTEGRACAOTOTVS",
  "INTEGRACAO_FP_SIP_FOLHA_PAGAMENTO",
  "GTVEPARAMETRIZACAOFISCAL",
  "CODIGORNTRC",
  "EMAILNOTIFICACAOSOLICITACAOMATERIALTEMPORARIO",
  "EMAILNOTIFICACAOSOLICITACAOCONSUMIVEL",
  "EMAILNOTIFICACAOSOLICITACAOUNIFORME",
  "UNIFORMENOTIFICACAODATASUBSTITUICAO",
  "LANCAMENTOSCONTABEISCONTADESCONTOSOBTIDOS",
  "LANCAMENTOSCONTABEISCONTADESCONTOSCONCEDIDOS",
  "LANCAMENTOSCONTABEISCONTAJUROSMORA",
  "LANCAMENTOSCONTABEISCONTAMULTASMORA",
  "LANCAMENTOSCONTABEISCONTAJUROSRECEBIDOS",
  "LANCAMENTOSCONTABEISCONTAMULTASRECEBIDOS",
  "INTEGRACAOTOTVSBODYCALCULOFOLHAPAGTO",
  "EMAILNOTIFICACAOGESTAOORCAMENTODESPESAS",
  "EMAILNOTIFICACAONOVASCONTRATACOES",
  "EMAILNOTIFICACAODESLIGAMENTOS",
  "RESTRINGIRJUSTIFICATIVAREGISTROPONTO",
  "CONTAFINANCEIRAFATURAMENTOSERVICOSCONTAVINCULADA",
  "NOTIFICACAOANIVERSARIOFUNCIONARIOS",
  "APPSOLICITACAOAFASTAMENTOOPCOES",
  "CONTAFINANCEIRAPADRAOTRANSFERENCIABNCARIADEBITOCREDITO",
  "IMAGEMRODAPERECIBOPAGAMENTO",
  "INTEGRACAOEQUIPAMENTOSPRIME",
  "INTEGRACAOEQUIPAMENTOSADVANCE",
  "INTEGRACAOEQUIPAMENTOSGUNNEBO",
  // "INTEGRARMOVIMENTACOESEQUIPAMENTOSSATELLITE",
  "SOLICITACAOAFASTAMENTOLIMITEDIASSOLIITACAOATESTADOMEDICO",
  "EMAILNOTIFICACAOLIMITECOLETAEQUIPAMENTOS",
  "BRADESCOAPIKEY",
  "BRADESCOCLIENTID",
  "BRADESCOAPISENHACONEXAO",
  "BRADESCOAPIKEYHOMOLOGACAO",
  "BRADESCOCLIENTIDHOMOLOGACAO",
  "BRADESCOAPISENHACONEXAOHOMOLOGACAO",
]);

const TIPOS_LISTA_EMAILS = new Set([
  "EMAILALERTASALDOTESOURARIA",
  "ARMAFOGONOTIFICACAOVINCUMENTOREGISTRO60DIAS",
  "COLETEBALISTICONOTIFICACAOVINCUMENTOREGISTRO90DIAS",
]);

const CATEGORIA_POR_TIPO = CATEGORIAS_PARAMETRIZACAO.reduce(
  (mapa, categoria) => {
    categoria.tipos.forEach((tipo) => {
      mapa[tipo] = categoria.id;
    });
    return mapa;
  },
  {}
);

export function tiposCatalogo() {
  return CATEGORIAS_PARAMETRIZACAO.flatMap((categoria) => categoria.tipos);
}

export function categoriaDoTipo(tipo) {
  return CATEGORIA_POR_TIPO[tipo] || CATEGORIA_OUTROS.id;
}

export function camposDoTipo(tipo) {
  const usaReferencia = Object.prototype.hasOwnProperty.call(
    REFERENCIA_POR_TIPO,
    tipo
  );
  return {
    referencia: usaReferencia,
    unidadeReferencia: usaReferencia ? REFERENCIA_POR_TIPO[tipo] : null,
    texto: TIPOS_TEXTO.has(tipo),
    listaEmails: TIPOS_LISTA_EMAILS.has(tipo),
  };
}

export function normalizarBusca(valor) {
  return String(valor || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim();
}

function valorVazio(valor) {
  return valor === null || valor === undefined || valor === "";
}

function normalizarEntrada(entrada) {
  return {
    ativo: entrada.ativo === true,
    referencia: valorVazio(entrada.referencia)
      ? null
      : Number(entrada.referencia),
    texto: valorVazio(entrada.texto) ? null : String(entrada.texto),
  };
}

function agruparPorTipo(entradas) {
  return (entradas || []).reduce((mapa, entrada) => {
    if (!entrada || !entrada.tipo) {
      return mapa;
    }
    (mapa[entrada.tipo] = mapa[entrada.tipo] || []).push(entrada);
    return mapa;
  }, {});
}

// Uma linha por registro vinculado e uma linha por tipo ainda não vinculado.
// Tipos repetidos geram uma linha por registro para não esconder dados; o
// primeiro registro mantém a chave do tipo para a linha não ser recriada.
export function montarItensParametrizacao(entradas, rotuloDoTipo) {
  const rotulo = rotuloDoTipo || ((tipo) => tipo);
  const porTipo = agruparPorTipo(entradas);
  const tipos = tiposCatalogo();
  const tiposForaCatalogo = Object.keys(porTipo).filter(
    (tipo) => !CATEGORIA_POR_TIPO[tipo]
  );

  return [...tipos, ...tiposForaCatalogo].flatMap((tipo) => {
    const base = {
      tipo,
      categoria: categoriaDoTipo(tipo),
      rotulo: rotulo(tipo),
      campos: camposDoTipo(tipo),
    };
    const registros = porTipo[tipo] || [];
    if (registros.length === 0) {
      return [{ ...base, chave: tipo, entrada: null, duplicada: false }];
    }
    return registros.map((entrada, indice) => ({
      ...base,
      chave: indice === 0 ? tipo : `${tipo}#${indice}`,
      entrada,
      duplicada: registros.length > 1,
    }));
  });
}

export function situacaoItem(item) {
  if (!item.entrada) {
    return "naoVinculada";
  }
  return item.entrada.ativo === true ? "ativa" : "inativa";
}

// Cada palavra buscada precisa aparecer no rótulo ou no código, em qualquer
// ordem: "folha ponto modelo" encontra "Folha de ponto modelo 10".
export function filtrarItens(itens, { busca, categoria, situacao } = {}) {
  const palavras = normalizarBusca(busca).split(/\s+/).filter(Boolean);
  return itens.filter((item) => {
    if (categoria && categoria !== "todas" && item.categoria !== categoria) {
      return false;
    }
    if (situacao === "vinculadas" && !item.entrada) {
      return false;
    }
    if (situacao === "naoVinculadas" && item.entrada) {
      return false;
    }
    if (palavras.length === 0) {
      return true;
    }
    const alvo = `${normalizarBusca(item.rotulo)} ${normalizarBusca(
      item.tipo
    )}`;
    return palavras.every((palavra) => alvo.includes(palavra));
  });
}

export function resumirItens(itens) {
  const tipos = new Set();
  let vinculadas = 0;
  let ativas = 0;
  itens.forEach((item) => {
    tipos.add(item.tipo);
    const situacao = situacaoItem(item);
    if (situacao !== "naoVinculada") {
      vinculadas += 1;
    }
    if (situacao === "ativa") {
      ativas += 1;
    }
  });
  return { total: tipos.size, vinculadas, ativas };
}

// Tipos cujo conjunto de registros difere do que foi carregado do servidor.
export function tiposAlterados(atuais, originais) {
  const porTipoAtual = agruparPorTipo(atuais);
  const porTipoOriginal = agruparPorTipo(originais);
  const tipos = new Set([
    ...Object.keys(porTipoAtual),
    ...Object.keys(porTipoOriginal),
  ]);
  const serializar = (registros) =>
    JSON.stringify((registros || []).map(normalizarEntrada));

  return [...tipos].filter(
    (tipo) =>
      serializar(porTipoAtual[tipo]) !== serializar(porTipoOriginal[tipo])
  );
}

export function criarEntrada(tipo) {
  return { tipo, ativo: true, referencia: null, texto: null };
}

export function referenciaConcomitanciaValida(valor) {
  if (
    valor === null ||
    valor === undefined ||
    (typeof valor === "string" && valor.trim() === "")
  ) {
    return true;
  }
  if (typeof valor !== "number" && typeof valor !== "string") {
    return false;
  }
  const numero = Number(valor);
  return Number.isInteger(numero) && numero >= 0 && numero <= 2147483647;
}

export function referenciaConcomitanciaOuNulo(valor) {
  if (
    valor === null ||
    valor === undefined ||
    (typeof valor === "string" && valor.trim() === "")
  ) {
    return null;
  }
  return referenciaConcomitanciaValida(valor) ? Number(valor) : valor;
}
